

import { useNavigate } from 'react-router-dom';
import { axiosApi as axios } from '../helpers/axiosApi';
import { toaster } from '../helpers/toaster';
import { eraseCookie, getCookie, setCookie } from './helpers';

class Auth {
  constructor() {
    this.authenticated = false;
    this.csrf = null;
  }

  checkToken = (cb) => {
    axios.get('/accounts/check-token/', {
      headers: {
        "Authorization": `Bearer ${getCookie('access')}`
      }
    })
    .then(res => {
      if(res.status === 200){
        this.authenticated = true;
        cb(true, res.data.data.usertype)
        // return true;
      }
      else{
        this.authenticated = false;
        cb(false, null)
        // return false;
      }
    })
    .catch((err) => {
      console.log(err);
      cb(false)
    });
  }

  login(credentials, cb, errorCb) {
    const { email, password } = credentials;

    axios.post("/accounts/login/", {
      email,
      password
    }, {
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": getCookie('csrftoken'),
      },
      credentials: "same-origin",
    })
    .then(res => {
      const {status,data} = res
      setCookie("access", res.data.access)
      setCookie("refresh", res.data.refresh)
      cb(res.data.data)
      if(status===200){
        toaster(data.message, "success")
      }
    })
    .catch(error => {
      toaster("Unable to sign in. Please check your credentials and try again.", "error")
      if (errorCb) errorCb(error)
    })
  }

  refreshToken = async () => {
    try {
      const refreshToken = getCookie('refresh');
      if (!refreshToken) {
        console.log('❌ No refresh token available');
        throw new Error('No refresh token available');
      }

      const response = await axios.post("/accounts/token/refresh/", {
        refresh: refreshToken
      }, {
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": getCookie('csrftoken'),
        },
      });

      const { access, refresh } = response.data;
      setCookie("access", access);
      setCookie("refresh", refresh);
      
      return access;
    } catch (error) {
      console.error('❌ Token refresh failed:', error);
      this.authenticated = false;
      eraseCookie("access");
      eraseCookie("refresh");
      // window.location.href = '/login';
      throw error;
    }
  }

  logout(cb) {

    axios.post("/accounts/logout/", {
      refresh: getCookie('refresh') 
    },
       {
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": getCookie('csrftoken'),
        "Authorization": `Bearer ${getCookie('access')}`
      },
    }).then(res => {
      if (cb) {
        this.authenticated = false;
        eraseCookie("access")
        eraseCookie("refresh")
        localStorage.removeItem('only_attachment')
        localStorage.removeItem('username')
        localStorage.removeItem('client')
        localStorage.removeItem('disableAnalytics')
        cb(false);
        toaster("Logout successful", "success")
      }
    })
  }

  isAuthenticated() {
    return this.authenticated;
  }
}

export default new Auth();
